import React, { useState } from 'react'
import { Link, useOutletContext, useSearchParams, Navigate } from 'react-router-dom';
import Loading from '../loading/Loading';


function Redirect() {
    const [searchParams] = useSearchParams();
    const params = Object.fromEntries([...searchParams]);
    const [state, setState ] = useState(params);
  return (
      <>
    <Loading />
    <Navigate 
        to={state.location}
        state = {{...state}}
    />
      </>
  )
}

export default Redirect